export default __webpack_public_path__ + "static/media/rafa8.d89fffb8.jpg";